<script>
  import {
    PlusIcon,
    XIcon,
    Edit3Icon,
    PhoneIcon,
  } from 'vue-feather-icons'
  import { resolvePhoneNumber } from '@utils/phoneNumber'

  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon,
      PhoneIcon,
    },
    props: {
      index: {
        type: Number,
        required: true,
      },
      phonesList: {
        type: Array,
        required: true,
      },
      formError: {
        type: Object,
        required: true,
      },
      formErrorPath: {
        type: String,
        required: true,
      },
      enforcePrimary: {
        type: Function,
        default: () => { return false },
      }
    },
    computed: {
    },
    methods: {
      resolvePhoneNumber,
      addContactPhone() {
        const isPrimary = !this.phonesList.length
        this.phonesList.push(
          {
            is_primary: isPrimary,
            is_edit: true
          }
        )
      },
      removeContactPhone(indexPhone) {
        const rebindPrimary = this.phonesList[indexPhone].is_primary
        this.phonesList.splice(indexPhone, 1)
        if (rebindPrimary && this.phonesList.length > 0) {
          this.phonesList[0].is_primary = true
        }
      },
      toggleEditContactPhone(indexPhone, toggle = true) {
        const phone = this.phonesList[indexPhone]
        phone.is_edit = toggle
        this.phonesList.splice(indexPhone, 1)
        this.phonesList.splice(indexPhone, 0, phone)
      },
      canUpdatePhone(indexPhone){
        const phone = this.phonesList[indexPhone]
        if (phone && phone.phone && phone.phone.length > 4){
          return true
        }
        return false
      },
      canRemovePhone(indexPhone){
        const usablePhones = this.phonesList.filter(el => el && el.phone)
        if (usablePhones && usablePhones.length > 1){
          return true
        }
        return !this.canUpdatePhone(indexPhone)
      },
    },
  };
</script>

<template>
  <BaseCollapseBox label="PHONE NUMBERS" name="phone_numbers">
    <div v-for="(phone, indexPhone) in phonesList" :key="indexPhone">
      <div
        v-if="!phone.is_edit"
        class="edit-form-item my-3"
        :class="{ 'border-col-error': formError[`${formErrorPath}.${indexPhone}.phone`] }">
        <div class="item-info">
          <div class="tw-w-full md:tw-w-2/3 tw-pl-4 left-ct tw-inline-flex tw-items-center" style="justify-content: unset">
            <span v-if="phone.is_primary" class="block-status border rounded-pill pl-1 mr-2 md:tw-hidden tw-flex">
              <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
            </span>
            <PhoneIcon size="1.2x" class="tw-mr-3 tw-min-w-6"/><p class="tx-value mg-b-0 text-bold tw-overflow-ellipsis tw-truncate"> {{resolvePhoneNumber(phone.phone, $store.state.businesses.locale || 'AU')}}</p>
          </div>
          <div class="tw-hidden md:tw-flex tw-w-1/3 right-ct">
            <span v-if="phone.is_primary" class="block-status border rounded-pill pl-1 tw-pr-4 md:tw-flex tw-hidden">
              <span class="status-icon status-completed"></span><span>(Primary)</span>
            </span>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button class="btn btn-icon button-action button-action-positive" @click="toggleEditContactPhone(indexPhone)">
            <Edit3Icon size="1x" />
          </button>
          <button v-if="canRemovePhone(indexPhone)" class="btn btn-icon button-action button-action-negative" @click="removeContactPhone(indexPhone)">
            <XIcon size="1x" />
          </button>
        </div>
      </div>
      <div v-else class=" border border-radius-20 my-3 tw-px-4 md:tw-px-5 tw-py-4 md:tw-py-5 bg-gray">
        <div class="group-block">
          <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <section class="tw-w-full lg:tw-w-3/4 tw-flex tw-flex-col sm:tw-flex-row">
              <div class="tw-w-full sm:tw-w-2/3">
                <div :class="['form-group', { 'is-invalid': formError[`${formErrorPath}.${indexPhone}.phone`] }]">
                  <label>Contact Phone Number</label>
                  <input
                    v-model="phonesList[indexPhone].phone"
                    maxlength="20"
                    type="number"
                    class="form-control hide-arrows"
                    placeholder="E.g. +61 412 123 123" />
                  <p v-if="formError && formError[`${formErrorPath}.${indexPhone}.phone`]" class="text-danger">{{ formError[`${formErrorPath}.${indexPhone}.phone`] }}</p>
                </div>
              </div>
              <div class="tw-w-full sm:tw-w-1/3 tw-inline-flex tw-items-center tw-justify-center tw-mb-4">
                <div class="tw-items-start sm:tw-mt-5">
                  <div class="col-md-2 pr-0 switch-button-custom">
                    <FabricCheckbox
                      v-model="phonesList[indexPhone].is_primary"
                      :disabled="phonesList[indexPhone].is_primary"
                      slot-classes="!tw-pl-3 tw-text-black"
                      switch
                      is-stacked
                      @update="enforcePrimary(index, 'phones', indexPhone)"
                    >Primary</FabricCheckbox>
                  </div>
                </div>
              </div>
            </section>
            <div class="tw-w-full lg:tw-w-1/4 tw-inline-flex tw-items-center tw-justify-around tw-flex-col xs:tw-flex-row lg:tw-flex-col">
              <button
                :disabled="!canUpdatePhone(indexPhone)"
                type="button"
                class="btn button button-dashed-positive tw-min-w-u xs:tw-min-w-2/5 tw-w-40 xs:tw-w-auto tw-mb-2 xs:tw-mb-0 md:tw-w-40 md:tw-min-w-u"
                @click="toggleEditContactPhone(indexPhone, false)"> Save </button>
              <button
                v-if="canRemovePhone(indexPhone)"
                type="button"
                class="btn button button-dashed-danger tw-min-w-u xs:tw-min-w-2/5 tw-w-40 xs:tw-w-auto md:tw-w-40 md:tw-min-w-u"
                @click="removeContactPhone(indexPhone)"> Remove </button>
            </div>
          </div>
        </div>
      </div>
      <p v-if="!phone.is_edit && formError && formError[`${formErrorPath}.${indexPhone}.phone`]" class="text-danger">{{ formError[`${formErrorPath}.${indexEmail}.phone`] }}</p>
    </div>
    <p v-if="formError && formError[`${formErrorPath}`]" class="text-danger">{{ formError[`${formErrorPath}`] }}</p>
    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addContactPhone">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Phone Number</span>
        </div>
      </button>
    </div>
  </BaseCollapseBox>
</template>
